export default __webpack_public_path__ + "static/media/2283.1f96ed7b.png";